import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { SetFlashMessageRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessagerequest';
// import { SetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse';
import { FlashMessageDto } from 'src/com/sixdee/crbtportal/core/dto/flashmessage/get/flashmessagedto';
import { GenerateOTPRequestImpl } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotprequest';
import { GenerateOTPResponse } from 'src/com/sixdee/crbtportal/core/api/otp/generateotp/generateotpresponse';
import { GenerateOTPDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/otp/generateotp/generateotpdto';
import { DedicateFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/dedicate/dedicateflashmessagesresponse';
import { FlashMessageGenerateTokenRequestImpl } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenrequest';
import { FlashMessageGenerateTokenResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessagegeneratetoken/flashmessagegeneratetokenresponse';
import { FlashMessageGenerateTokenDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/flashmessagegenereratetoken/flashmessagegeneratetoken';
import { SetFlashMessageResponse } from 'src/com/sixdee/crbtportal/core/api/flashmessage/setflashmessge/setflashmessageresponse';

export interface SubscriptionFlashMessageComponentAPIModel extends APIModel 
{
  generateOTP(flashMessageDto: FlashMessageDto): void ;
  setFlashMessage(flashMessageDto: FlashMessageDto): void;
  setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void;
}

export class SubscriptionFlashMessageComponentAPIModelImpl extends APIModelImpl implements SubscriptionFlashMessageComponentAPIModel 
{
   
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler) 
    {
        super(applicationContext, apiModelHandler);
      
    }
  generateOTP(flashMessageDto: FlashMessageDto): void 
  {
    let generateOtp = new GenerateOTPDtoImpl();
    generateOtp.setMsisdn(flashMessageDto.getMsisdn());
    
    this.getContext().getAPIProcessorFactory().getLoginAPIProcessorFactory().generateOTP()
                .success((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onSuccess(generateOTPResponse.getAPIFeature(), 
                    generateOTPResponse.getDescription(), generateOTPResponse);
                })
                .failure((generateOTPResponse : GenerateOTPResponse)=>
                {
                    this.getAPIModelHandler().onFailure(generateOTPResponse.getAPIFeature(), 
                         generateOTPResponse.getDescription(), generateOTPResponse);

                }).execute(new GenerateOTPRequestImpl(generateOtp));
  }

    setFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      console.log("setFlashMessage");

      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse1: FlashMessageGenerateTokenResponse) => 
      {
          this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().setFlashMessageAPIProcessor()
          .success((subscriberValidationResponse: SetFlashMessageResponse) => {
            this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
            subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .failure((subscriberValidationResponse: SetFlashMessageResponse) => {
              this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                  subscriberValidationResponse.getDescription(), subscriberValidationResponse);
          })
          .execute(new SetFlashMessageRequestImpl(flashMessageDto));
        })
        .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => 
        {
            this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                subscriberValidationResponse.getDescription(), subscriberValidationResponse);
        })
        .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
    }

    setSpecialCallerFlashMessage(flashMessageDto: FlashMessageDto): void
    {
      console.log("setSpecialCallerFlashMessage");
      let tokenDto = new FlashMessageGenerateTokenDtoImpl();
      tokenDto.setMsisdn(flashMessageDto.getMsisdn());
      
      this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().generateTokenProcessor()
      .success((subscriberValidationResponse1: FlashMessageGenerateTokenResponse) => 
      {
        this.getAPIProcesssorFactory().getFlashMessageProcessorFactory().getDedicateFlashAPIProcessor()
            .success((subscriberValidationResponse: DedicateFlashMessageResponse) => {
              this.getAPIModelHandler().onSuccess(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
            })
            .failure((subscriberValidationResponse: DedicateFlashMessageResponse) => {
                this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
                subscriberValidationResponse.getDescription(), subscriberValidationResponse1);
            })
            .execute(new SetFlashMessageRequestImpl(flashMessageDto));
      })
      .failure((subscriberValidationResponse: FlashMessageGenerateTokenResponse) => {
          this.getAPIModelHandler().onFailure(subscriberValidationResponse.getAPIFeature(),
              subscriberValidationResponse.getDescription(), subscriberValidationResponse);
      })
      .execute(new FlashMessageGenerateTokenRequestImpl(tokenDto));
     
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/flashmessage/flashsubscription/flashsubsciptionapimodel.tsx